import * as counterpart from 'counterpart';
import * as Translate from 'react-translate-component';

let lang = Office.context.displayLanguage.substring(0, 2)
if (['en', 'de'].indexOf(lang) < 0) {
    lang = 'en';
}

export const displayLanguage = lang;

counterpart.setLocale(lang);

counterpart.registerTranslations('en', {
    transformTags: 'Transform Tags',
    settings: 'Settings',
    highlightAllTags: 'Highlight all Tags',
    disableHighlightingOfTags: 'Disable Highlighting of Tags',
    search: 'Search...'
});

counterpart.registerTranslations('de', {
    transformTags: 'Tags umwandeln',
    settings: 'Einstellungen',
    highlightAllTags: 'Alle Tags hervorheben',
    disableHighlightingOfTags: 'Tags nicht mehr hervorheben',
    search: 'Suchen...'
});

export const translation = counterpart;
export const TranslateComponent = Translate;



// WEBPACK FOOTER //
// ./util/translations.tsx